/**
 * Unified Filters Component
 * Consistent filter section for all management pages
 */

import React from 'react';
import './UnifiedFilters.css';

const UnifiedFilters = ({
    searchValue,
    onSearchChange,
    onSearchSubmit,
    quickFilters = [],
    onQuickFilterClick,
    children
}) => {
    return (
        <div className="unified-filters-section">
            <div className="unified-search-filters-grid">
                {/* Quick Search - Left Side */}
                <div className="unified-search-section">
                    <div className="unified-form-group">
                        <label className="unified-form-label">Quick Search</label>
                        <div className="unified-search-input-container">
                            <input
                                type="text"
                                className="unified-form-input"
                                placeholder="Search by name, email, ID, city, state..."
                                value={searchValue}
                                onChange={(e) => onSearchChange(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        onSearchSubmit();
                                    }
                                }}
                            />
                            <button
                                className="unified-search-button"
                                onClick={onSearchSubmit}
                                type="button"
                            >
                                🔍
                            </button>
                        </div>
                    </div>
                </div>

                {/* Quick Filters - Right Side */}
                <div className="unified-filters-section-right">
                    <div className="unified-form-group">
                        <label className="unified-form-label">Quick Filters</label>
                        <div className="unified-quick-filters">
                            {quickFilters.map((filter, index) => (
                                <button
                                    key={index}
                                    className={`unified-quick-filter-btn ${filter.active ? 'active' : ''}`}
                                    onClick={() => onQuickFilterClick(filter.key)}
                                    data-filter={filter.key}
                                >
                                    {filter.label}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Additional Filter Content */}
            {children && (
                <div className="unified-additional-filters">
                    {children}
                </div>
            )}
        </div>
    );
};

export default UnifiedFilters;
